import { FEATURES, useFeaturesStore, type FeatureName } from '@/stores/features'
import type { PropsWithChildren } from 'react'

type FeatureProps = PropsWithChildren<{ name: FeatureName }>

export const Feature = ({ children, name }: FeatureProps) => {
  const isDisabled = useFeaturesStore(
    state => state.disabled[name] === FEATURES[name],
  )

  if (isDisabled) return

  return children
}
